export default class Toast {
	constructor() {
		this._id = 0; // 消息ID
		this._prev_end_at = 0; // 上个消息关闭时间，不考虑主动关闭情况
		this.data = [];
	}
	push(msg) {
		var now = Date.now();
		msg.text += "";
		if (typeof msg.timeout != "number")
			// 默认停留时间与消息长度相关
			msg.timeout = 1e3 + msg.text.length * 200;
		if (this._prev_end_at > now)
			// 如果上个消息还没结束
			msg.timeout += this._prev_end_at - now;
		this._prev_end_at = now + msg.timeout;
		msg.remove = () => this.remove(msg);
		msg.id = ++this._id;
		setTimeout(msg.remove, msg.timeout);
		this.data.push(msg);
	}
	remove(msg) {
		var idx = this.data.indexOf(msg);
		if (idx >= 0) {
			this.data.splice(idx, 1);
		}
	}
	show(text, opt) {
		this.push(Object.assign({text}, opt));
	}
	success(text, opt) {
		this.push(Object.assign({text, status: "success"}, opt));
	}
	error(text, opt) {
		this.push(Object.assign({text, status: "error"}, opt));
	}
}
